import { render, staticRenderFns } from "./promiseGoodsWrhsWorkMngt.vue?vue&type=template&id=64af72c6"
import script from "./promiseGoodsWrhsWorkMngt.vue?vue&type=script&lang=js"
export * from "./promiseGoodsWrhsWorkMngt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports